import site from './profile/pl/site';
import footer from './profile/pl/footer';
import home from './profile/pl/home';
import about from './profile/pl/about';
import projectsPage from './profile/pl/projectsPage';
import projects from './profile/pl/projects';
import expertise from './profile/pl/expertise';
import contact from './profile/pl/contact';

const profileContentPl = {
  site,
  footer,
  home,
  about,
  projectsPage,
  projects,
  expertise,
  contact,
};

export default profileContentPl;
